export enum PromotionPopupShowAtType {
    PLATFORM_ACCESS = 'Acceso a la plataforma',
    ON_FIRST_CLICK = 'Tras el primer clic',
    COURSE_COMPLETION = 'Completar un curso',
}